import { authcallApi, callApi } from "../../../common/API/Api";
import Timezone from "../TimeZone";
let serverTimeOffset = 0;

export const getServerTime = async (attempts = 5) => {
  try {
    let bestOffset = null;
    let bestRTT = Infinity;

    for (let i = 0; i < attempts; i++) {
      const t0 = performance.now();

      const response = await callApi({}, `api/server-time`, "GET");
      const t1 = performance.now();

      if (!response?.data?.success) {
        throw new Error("Failed to fetch server time");
      }

      const data = response.data;
      const serverTime = new Date(data.server_time).getTime(); // ensure timestamp in ms

      const clientReceiveTime = Date.now();
      const rtt = t1 - t0;
      const offset = serverTime - clientReceiveTime;

      if (rtt < bestRTT) {
        bestRTT = rtt;
        bestOffset = data.server_time;
      }
    }

    serverTimeOffset = bestOffset;
    console.log(`Best server time offset after ${attempts} tries: ${serverTimeOffset} ms`);

    return {
        success:true,
      server_time: serverTimeOffset,
      adjustedTime: new Date(Date.now() + serverTimeOffset).toISOString(),
    };
  } catch (error) {
    console.error("Error syncing server time:", error);
    return null;
  }
};
export const gettimezoneprefrence = async () => {
    try {
      let postdata = {};
      let res = await authcallApi(
        postdata,
        `api/preference?key=timezoneshow`,
        "GET"
      );
      if (res?.data?.success) {
        const parsedValue = JSON.parse(res?.data.value);
        return parsedValue
      } else {
        const offset = -new Date().getTimezoneOffset(); 
        const sign = offset >= 0 ? "+" : "-";
        const absOffset = Math.abs(offset);
        const hours = String(Math.floor(absOffset / 60)).padStart(2, "0");
        const minutes = String(absOffset % 60).padStart(2, "0");
        const timeZone = `${sign}${hours}:${minutes}`;
        let object;
        if (Timezone?.length) {
          object = Timezone.find((item) => item?.time === timeZone);
        }
        if (!object) {
          const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
          if (tz === "Asia/Kolkata") {
            object = {
              value: "UTC +05:30",
              time: "+05:30",
              timezone: "Asia/Kolkata",
              haur: "05",
              minute: "30",
              plus: "+",
            };
          } else {
            object = {
              value: `UTC ${timeZone}`,
              time: timeZone,
              timezone: tz || "UTC",
              haur: hours,
              minute: minutes,
              plus: sign,
            };
          }
        }
  return object
      
      }
    } catch (err) {
      console.log(err, "err");
    }
  };

  export const adjustToTimezone = (serverTime, tzOffset) => {
  if (!tzOffset) return serverTime;
  const sign = tzOffset[0] === "+" ? 1 : -1;
  const [hours, minutes] = tzOffset.slice(1).split(":").map(Number);

  const offsetMs = sign * (hours * 60 * 60 * 1000 + minutes * 60 * 1000);
  return serverTime + offsetMs;
};

export const convertToServerTime = (localTime, tzOffset) => {
  if (!tzOffset) return localTime;
  const sign = tzOffset[0] === "+" ? 1 : -1;
  const [hours, minutes] = tzOffset.slice(1).split(":").map(Number);

  const offsetMs = sign * (hours * 60 * 60 * 1000 + minutes * 60 * 1000);
  return localTime - offsetMs;
};